import React from 'react';
import { Icon } from '../Icon/Icon.jsx';
import { Tooltip } from '../Tooltip/Tooltip.jsx';
import { ink } from '../../primitives.js';

const h = React.createElement;

/**
 * Icon-only button. `label` is required (tooltip + accessible name).
 *
 * @param {object} p
 * @param {string} p.icon
 * @param {string} p.label
 * @param {React.MouseEventHandler} [p.onClick]
 * @param {'sm'|'md'} [p.size]
 * @param {boolean} [p.framed]
 * @param {boolean} [p.active]
 * @param {boolean} [p.danger]
 * @param {boolean} [p.disabled]
 * @param {React.CSSProperties} [p.style]
 */
export function IconBtn({ icon, label, onClick, size = 'md', framed, active, danger, disabled, style }) {
  const S = size === 'sm' ? 28 : 34, I = size === 'sm' ? 15 : 17;
  const btn = h('button', {
    type: 'button', 'aria-label': label, 'aria-pressed': active != null ? !!active : undefined, disabled, onClick: disabled ? undefined : onClick,
    className: 'gx-iconbtn gx-hit' + (framed && !disabled ? ' mo-lift mo-stamp' : ''),
    style: { position: 'relative', display: 'inline-grid', placeItems: 'center', width: S, height: S, padding: 0, flex: 'none', borderRadius: size === 'sm' ? 8 : 10, border: framed ? ink(2) : '2px solid transparent', background: active ? 'var(--sel)' : framed ? 'var(--card)' : 'transparent', boxShadow: framed ? 'var(--el-1)' : 'none', color: danger ? 'var(--coral-tx)' : 'var(--tx)', cursor: disabled ? 'default' : 'pointer', opacity: disabled ? .45 : 1, ...style }
  }, h(Icon, { name: icon, size: I }));
  return Tooltip ? h(Tooltip, { label }, btn) : btn;
}
